module.exports = __webpack_public_path__ + "img/share-qrcode-img.a00823c9.png";